import { searchByPostalCodeForRegistrationAndSignup } from "../../../search-address";
/**
 * リアル展示会_来場事前登録兼会員情報登録画面の初期化
 */
export function initSampleSeriesRegistrationAndSignup() {
    const registrationAndSignupFormArticle = document.querySelector("[data-registration-and-signup-form-article]");
    if (!registrationAndSignupFormArticle)
        return;
    initSearchAddressButton();
    initSetVerifiedAt();
}
/**
 * 住所検索ボタンの初期化
 */
function initSearchAddressButton() {
    const button = document.getElementById("sample-series-webooth-registration-and-signup-search-address-button");
    if (button === null)
        return;
    button.addEventListener("click", async () => {
        const postCodeForm = document.getElementById('post_code_form');
        const postalCodeError0 = document.getElementById('post_code_error0');
        const postalCodeError1 = document.getElementById('post_code_error1');
        const postalCodeErrorElement0 = document.getElementById('postal_code_0_error');
        const postalCodeErrorElement1 = document.getElementById('postal_code_1_error');
        if (postCodeForm instanceof HTMLElement) {
            postCodeForm.classList.remove('form-error');
        }
        if (postalCodeErrorElement0) {
            postalCodeErrorElement0.innerHTML = ``;
        }
        if (postalCodeErrorElement1) {
            postalCodeErrorElement1.innerHTML = ``;
        }
        if (postalCodeError0) {
            postalCodeError0.innerHTML = ``;
        }
        if (postalCodeError1) {
            postalCodeError1.innerHTML = ``;
        }
        const code1 = document.getElementById("postal-code-1").value;
        const code2 = document.getElementById("postal-code-2").value;
        const postalCode = code1 + "-" + code2;
        try {
            const data = await searchByPostalCodeForRegistrationAndSignup(postalCode);
            if (data === null) {
                postCodeForm.classList.add('form-error');
                if (postalCodeError0) {
                    postalCodeError0.innerHTML = `郵便番号上３桁には数値を指定してください。`;
                }
                if (postalCodeError1) {
                    postalCodeError1.innerHTML = `郵便番号下４桁には数値を指定してください。`;
                }
                alert("住所が見つかりませんでした。");
                return;
            }
            const options = document.getElementsByClassName("prefecture-option");
            for (const option of options) {
                if (option.text === data.prefecture) {
                    option.selected = true;
                }
                else {
                    option.removeAttribute("selected");
                }
            }
            const input = document.getElementById("address1");
            input.value = data.address;
        }
        catch (error) {
            alert("住所が見つかりませんでした。");
        }
    });
}
/**
 * メール認証日時をconfirmに持ち回す
 */
function initSetVerifiedAt() {
    const now = new Date();
    const month = now.getMonth() + 1;
    const verifiedDatetimeString = now.getFullYear() + "-" + month + "-" + now.getDate() + " " + now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds();
    sessionStorage.setItem("verified_at", verifiedDatetimeString);
}
